import React from "react";


import Dashboard from "../Pages/Dashboard";

const DashboardStudent = () => {
  return (
    <div>
      <div className="container-fluid">
        <Dashboard />
      </div>
    </div>
  );
};

export default DashboardStudent;
